export default "__VITE_ASSET__BYFBf91t__"